import { Price } from "@/types/price";
import { Coupon } from "@/types/PromotionCode";

export function formatMoneyWithCurrency(
    amountInCents: number,
    currencyCode: string,
): string {
    const amount = amountInCents / 100;
    const isWholeNumber = Math.floor(amount) === amount;
    const decimals = isWholeNumber ? 0 : 2;

    // Format number with appropriate decimal places
    const formattedAmount = amount.toLocaleString("en-US", {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    });

    switch (currencyCode) {
        case "cad":
            return `$${formattedAmount} CAD`;
        default:
            return `$${formattedAmount}`;
    }
}

export function formatPrice(price: Price, coupon?: Coupon | null): string {
    if (!price?.amountForDisplay) return "$0";

    const basePrice = Number(price.amount);
    const amountOff = Number(coupon?.amountOff ?? 0);
    const percentOff = Number(coupon?.percentOff ?? 0);

    if (amountOff > 0) {
        return formatMoneyWithCurrency(basePrice - amountOff, price.currency);
    }

    if (percentOff > 0) {
        const discountPrice = basePrice * (1 - percentOff / 100);
        return formatMoneyWithCurrency(discountPrice, price.currency);
    }

    return formatMoneyWithCurrency(basePrice, price.currency);
}

export function applyDiscountToCents(
    baseCents: number,
    coupon: Coupon | null | undefined,
): number {
    if (coupon?.amountOff) {
        return Math.max(0, baseCents - coupon.amountOff);
    }

    if (coupon?.percentOff) {
        return Math.round((baseCents * (100 - coupon.percentOff)) / 100);
    }

    return baseCents;
}

export function getCurrencyFromLocale(): string {
    const locale = navigator.language || navigator.languages[0] || "en-US";
    switch (locale) {
        case "en-CA":
            return "cad";
        case "fr-CA":
            return "cad";
        default:
            return "usd";
    }
}
